/**
 * Buy now: add current variant to cart, auto-apply promo (FIRST10), then go to checkout.
 * Matches web checkout: discount applied and totals shown after discount.
 * If the variant is already in the cart (max qty), skip re-add and go to checkout.
 */
(function () {
  'use strict';

  var CHECKOUT_URL =
    (window.kunjareeCheckoutUrl || '/pages/checkout').replace(/\/$/, '') ||
    '/pages/checkout';

  function getCheckoutUrl() {
    if (CHECKOUT_URL.charAt(0) === '/') {
      return CHECKOUT_URL;
    }
    return '/' + CHECKOUT_URL;
  }

  function showError(productForm, message) {
    var wrapper = productForm.querySelector('.product-form__error-message-wrapper');
    var messageEl = productForm.querySelector('.product-form__error-message');
    if (!wrapper || !messageEl) {
      window.alert(message);
      return;
    }
    messageEl.textContent = message;
    wrapper.removeAttribute('hidden');
    wrapper.classList.remove('no-js-inline');
  }

  function clearError(productForm) {
    var wrapper = productForm.querySelector('.product-form__error-message-wrapper');
    if (!wrapper) return;
    wrapper.setAttribute('hidden', '');
    wrapper.classList.add('no-js-inline');
  }

  function readFormPayload(form) {
    var idInput = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    var variantId = idInput ? parseInt(idInput.value, 10) : NaN;
    var quantity = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    if (!quantity || quantity < 1) quantity = 1;
    return { variantId: variantId, quantity: quantity };
  }

  function goToCheckoutWithPromo() {
    var checkoutUrl = getCheckoutUrl();
    if (window.KunjareeCartDiscount && typeof KunjareeCartDiscount.autoApplyPromo === 'function') {
      return KunjareeCartDiscount.autoApplyPromo({ redirectPath: checkoutUrl }).then(function (result) {
        if (result && result.redirected) return;
        window.location.href = checkoutUrl;
      }).catch(function () {
        window.location.href = checkoutUrl;
      });
    }
    window.location.href = checkoutUrl;
    return Promise.resolve();
  }

  function cartHasVariant(cart, variantId) {
    if (!cart || !cart.items || !cart.items.length) return false;
    return cart.items.some(function (item) {
      return Number(item.variant_id || item.id) === Number(variantId);
    });
  }

  function isAlreadyInCartError(data) {
    var msg = String((data && (data.description || data.message)) || '').toLowerCase();
    return (
      msg.indexOf('already in your cart') !== -1 ||
      msg.indexOf('maximum quantity') !== -1 ||
      msg.indexOf('all 1') !== -1 ||
      msg.indexOf('cannot add more') !== -1
    );
  }

  async function fetchCart() {
    try {
      var response = await fetch((window.routes && window.routes.cart_url) || '/cart.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      });
      if (!response.ok) return null;
      return response.json();
    } catch (e) {
      return null;
    }
  }

  async function addToCartAndCheckout(btn) {
    var productForm = btn.closest('product-form');
    if (!productForm) return;

    var form = productForm.querySelector('form');
    if (!form) return;

    var payload = readFormPayload(form);
    if (!payload.variantId || isNaN(payload.variantId)) {
      showError(productForm, 'Please select a valid product option.');
      return;
    }

    clearError(productForm);
    btn.setAttribute('disabled', 'disabled');
    btn.classList.add('loading');
    var label = btn.querySelector('.kunjaree-buy-now__label');
    var originalText = label ? label.textContent : btn.textContent;

    if (label) {
      label.textContent = 'Processing…';
    }

    try {
      // Already in cart → go checkout (Buy Now intent), don't fail like Add to cart
      var cart = await fetchCart();
      if (cartHasVariant(cart, payload.variantId)) {
        await goToCheckoutWithPromo();
        return;
      }

      var response = await fetch(
        (window.routes && window.routes.cart_add_url) || '/cart/add.js',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            items: [{ id: payload.variantId, quantity: payload.quantity }],
          }),
        }
      );

      var data = await response.json();
      if (!response.ok || data.status) {
        // Race: ATC just filled cart to max — still proceed to checkout
        if (isAlreadyInCartError(data) || cartHasVariant(await fetchCart(), payload.variantId)) {
          await goToCheckoutWithPromo();
          return;
        }
        var errMsg =
          (data && (data.description || data.message)) ||
          'Could not add this item to your cart. Please try again.';
        showError(productForm, errMsg);
        return;
      }

      await goToCheckoutWithPromo();
    } catch (err) {
      console.error('[Kunjaree Buy Now]', err);
      showError(productForm, 'Something went wrong. Please try again.');
    } finally {
      btn.classList.remove('loading');
      btn.removeAttribute('disabled');
      if (label) {
        label.textContent = originalText;
      }
    }
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.kunjaree-buy-now');
    if (!btn || btn.disabled) return;
    event.preventDefault();
    addToCartAndCheckout(btn);
  });
})();
